import request from '@/utils/request'

// 查询公告列表
export function listNotice(query) {
  return request({
    url: '/system/notice/list',
    method: 'get',
    params: query
  })
}

// 查询公告详细
export function getNotice(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'get'
  })
}

// 新增公告
export function addNotice(data) {
  return request({
    url: '/system/notice',
    method: 'post',
    data: data
  })
}

// 修改公告
export function updateNotice(data) {
  return request({
    url: '/system/notice',
    method: 'put',
    data: data
  })
}

// 删除公告
export function delNotice(noticeId) {
  return request({
    url: '/system/notice/' + noticeId,
    method: 'delete'
  })
}

/**
 * 获取待办数量
 */
export const getTodoCount = () => {
  return request({
    url: '/mmscm-flow/workflow/process/todoNum',
    method: 'get',
  })
}
/**
 * 获取待办数量
 */
export const getCopyCount = () => {
  return request({
    url: '/mmscm-flow/workflow/process/copyNum',
    method: 'get',
  })
}
/**
 * 获取合同到期数量
 */
export const getExpireCount = () => {
  return request({
    url: '/mmscm-system/contract/getExpireCount',
    method: 'get',
  })
}
/**
 * 获取客户合同到期数量
 */
export const getCustomerExpireCount = () => {
  return request({
    url: '/mmscm-system/contract/getCustomerExpireCount',
    method: 'get',
  })
}